<script setup lang="ts">
import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useUserMutation } from '@/api/mutations/user/useUserMutation';
import { useLanguageList } from '@/hooks/useLanguageList';
import { type Locale, useLocaleStore } from '@/stores/locales';

const { currentLocale } = storeToRefs(useLocaleStore());
const { languagesList, getLanguageKey } = useLanguageList();

const isLanguageActive = (id: number) => currentLocale.value.id === id;

const selection = ref(currentLocale.value);
const { updateUser: updateLocale } = useUserMutation(
  computed(() => ({ locale_id: selection.value.id })),
);

function updateAuthLocale(locale: Locale) {
  selection.value = locale;
  updateLocale();
}
</script>

<template>
  <v-list-group color="contrast" class="p-0 font-icon-2">
    <template v-slot:activator="{ props }">
      <v-list-item
        v-bind="props"
        prepend-icon="fat fa-earth-americas"
        color="contrast"
        class="px-5 mb-0"
      >
        <span class="text-body-3">
          {{ $t(getLanguageKey(currentLocale?.iso_code_639 as string)) }}
        </span>

        <template #append>
          <v-icon icon="fat fa-chevron-down" size="20"></v-icon>
        </template>
      </v-list-item>
    </template>

    <v-list-item
      v-for="(item, i) in languagesList"
      class="mb-0"
      :key="i"
      :value="item"
      color="contrast"
      :active="isLanguageActive(item.id)"
      @click="updateAuthLocale(item)"
    >
      <span class="text-body-4 font-light">{{ item.title }}</span>

      <template v-if="isLanguageActive(item.id)" #append>
        <v-icon icon="fat fa-check" class="font-icon-2"></v-icon>
      </template>
    </v-list-item>
  </v-list-group>
</template>
